$(document).ready(function () {
  let planDurationSelect = $(document).find('.js-plan-select');
  if (planDurationSelect.length) {
    planDurationSelect.select2({
      placeholder: 'Plan Duration',
      minimumResultsForSearch: -1,
    });
  }
});
